import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';

// import axios from '../../config/axios';
import Header from '../Admin/components/Header/Header';
import SearchBar from '../../components/SearchBar/SearchBar';
import TableList from '../../pages/Admin/components/TableList/TableList';
import { BrowserRouter, Switch, Route, Link } from 'react-router-dom';
import CreateAdmin from '../CreateAdmin/CreateAdmin';

import axios from 'axios';
import { get_admins } from '../../api/API';

const useStyles = makeStyles(theme => ({
    root: {
        padding: 8
    },

    results: {
        marginTop: theme.spacing(3)
    }
}));

export default function Admin() {

    const classes = useStyles();
    const [admins, setAdmins] = useState([]);

    useEffect(() => {
        let mounted = true;







        fetchAdmins();

        return () => {
            mounted = false;
        };
    }, []);

    const fetchAdmins = async () => {

        let data = await get_admins();
        if (data) {
            setAdmins(data);
        } else {
            window.localStorage.clear();
            alert("Authentication broken");
            window.location.href = "/";
        }


    }
    // const handleFilter = () => {};
    // const handleSearch = () => {};

    return (
        <div
            className={classes.root}
            title="Admin Details"
        >
            <Header />

            {/* <SearchBar
                onSearch={handleSearch}
            /> */}

            {admins && (
                <TableList
                    className={classes.results}
                    admins={admins}
                    refresh={fetchAdmins}
                />
            )}
        </div>



    )
}

// import React, { Component } from 'react'
// import axios from 'axios';

// const api = axios.create({
//     baseURL: 'http://178.128.126.187/pvp/api/get_games'      
// })


// export default class Admin extends Component {

//     state = {
//         games : []
//     }

//     constructor(){
//         super();
//         api.get('/').then(res=>{
//             console.log(res.data)
//             this.setState({ games: res.data});

//         })
//     }

//     render() {
//         return (
//             <div>
//                 { this.state.games.map(game => <p key={game.game_id}>{game.game}</p>)}
//             </div>
//         )
//     }
// }
